<template>
  <div class="url-download-logs">
    <!-- 顶部操作栏 -->
    <div class="operation-bar">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            v-model="searchForm.username"
            placeholder="请输入用户名"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
            <i slot="prefix" class="el-input__icon el-icon-user"></i>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            v-model="searchForm.gameName"
            placeholder="请输入游戏名称"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
            <i slot="prefix" class="el-input__icon el-icon-game-controller"></i>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            v-model="searchForm.ip"
            placeholder="请输入IP地址"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
            <i slot="prefix" class="el-input__icon el-icon-location"></i>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="handleDateChange"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 15px">
        <el-col :span="24" style="text-align: right">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
        </el-col>
      </el-row>
    </div>

    <!-- 统计卡片 -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon" style="background: #ecf5ff">
            <i class="el-icon-download" style="color: #409eff"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ statistics.total }}</div>
            <div class="stat-label">总下载次数</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon" style="background: #f0f9ff">
            <i class="el-icon-user" style="color: #67c23a"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ statistics.uniqueUsers }}</div>
            <div class="stat-label">独立用户数</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon" style="background: #fef0f0">
            <i class="el-icon-monitor" style="color: #e6a23c"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ statistics.uniqueIPs }}</div>
            <div class="stat-label">独立IP数</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card">
          <div class="stat-icon" style="background: #f4f4f5">
            <i class="el-icon-folder-opened" style="color: #909399"></i>
          </div>
          <div class="stat-content">
            <div class="stat-value">{{ statistics.uniqueGames }}</div>
            <div class="stat-label">游戏数量</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 下载日志列表 -->
    <div class="table-container">
      <el-table :data="logList" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column prop="username" label="用户名" width="120"></el-table-column>
        <el-table-column prop="game_name" label="游戏名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="file_name" label="文件名" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ip_address" label="IP地址" width="140"></el-table-column>
        <el-table-column prop="created_at" label="下载时间" width="160">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="showDetail(scope.row)"
            >
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog
      title="下载详情"
      :visible.sync="detailDialogVisible"
      width="700px"
    >
      <div class="detail-content">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="记录ID">
            {{ currentDetail.id }}
          </el-descriptions-item>
          <el-descriptions-item label="用户ID">
            {{ currentDetail.user_id }}
          </el-descriptions-item>
          <el-descriptions-item label="用户名">
            {{ currentDetail.username }}
          </el-descriptions-item>
          <el-descriptions-item label="资源ID">
            {{ currentDetail.resource_id }}
          </el-descriptions-item>
          <el-descriptions-item label="游戏名称" :span="2">
            {{ currentDetail.game_name }}
          </el-descriptions-item>
          <el-descriptions-item label="文件名" :span="2">
            {{ currentDetail.file_name }}
          </el-descriptions-item>
          <el-descriptions-item label="IP地址">
            {{ currentDetail.ip_address }}
          </el-descriptions-item>
          <el-descriptions-item label="下载时间">
            {{ formatDate(currentDetail.created_at) }}
          </el-descriptions-item>
          <el-descriptions-item label="User Agent" :span="2">
            <div class="user-agent-text">{{ currentDetail.user_agent }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="下载链接" :span="2">
            <el-input
              v-model="currentDetail.download_url"
              readonly
              size="small"
            >
              <el-button
                slot="append"
                icon="el-icon-document-copy"
                @click="copyToClipboard(currentDetail.download_url)"
              ></el-button>
            </el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUrlDownloadLogs } from "../api/index";

export default {
  name: "UrlDownloadLogs",
  data() {
    return {
      loading: false,
      logList: [],
      dateRange: [],
      searchForm: {
        username: "",
        ip: "",
        gameName: "",
      },
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      statistics: {
        total: 0,
        uniqueUsers: 0,
        uniqueIPs: 0,
        uniqueGames: 0,
      },
      detailDialogVisible: false,
      currentDetail: {
        id: "",
        user_id: "",
        username: "",
        resource_id: "",
        file_name: "",
        game_name: "",
        ip_address: "",
        download_url: "",
        created_at: "",
        user_agent: "",
      },
    };
  },
  created() {
    this.fetchLogList();
  },
  methods: {
    // 获取日志列表
    async fetchLogList() {
      try {
        this.loading = true;
        const params = {
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          ...this.searchForm,
        };

        // 添加日期范围参数
        if (this.dateRange && this.dateRange.length === 2) {
          params.startDate = this.dateRange[0];
          params.endDate = this.dateRange[1];
        }

        const res = await getUrlDownloadLogs(params);
        this.logList = res.data.list;
        this.pagination.total = res.data.pagination.total;

        // 更新统计数据
        this.updateStatistics();
      } catch (error) {
        console.error(error);
        this.$message.error("获取下载日志失败");
      } finally {
        this.loading = false;
      }
    },

    // 更新统计数据
    updateStatistics() {
      // 从当前列表中计算统计数据
      const uniqueUsers = new Set(this.logList.map(item => item.user_id));
      const uniqueIPs = new Set(this.logList.map(item => item.ip_address));
      const uniqueGames = new Set(this.logList.map(item => item.resource_id));

      this.statistics = {
        total: this.pagination.total,
        uniqueUsers: uniqueUsers.size,
        uniqueIPs: uniqueIPs.size,
        uniqueGames: uniqueGames.size,
      };
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchLogList();
    },

    // 重置
    handleReset() {
      this.searchForm = {
        username: "",
        ip: "",
        gameName: "",
      };
      this.dateRange = [];
      this.pagination.currentPage = 1;
      this.fetchLogList();
    },

    // 日期范围改变
    handleDateChange() {
      this.handleSearch();
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchLogList();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchLogList();
    },

    // 格式化日期
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")} ${String(
        d.getHours()
      ).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}:${String(
        d.getSeconds()
      ).padStart(2, "0")}`;
    },

    // 显示详情
    showDetail(row) {
      this.currentDetail = {
        id: row.id,
        user_id: row.user_id,
        username: row.username,
        resource_id: row.resource_id,
        file_name: row.file_name,
        game_name: row.game_name,
        ip_address: row.ip_address,
        download_url: row.download_url,
        created_at: row.created_at,
        user_agent: row.user_agent || "未知",
      };
      this.detailDialogVisible = true;
    },

    // 复制到剪贴板
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success("已复制到剪贴板");
        }).catch(() => {
          this.fallbackCopyTextToClipboard(text);
        });
      } else {
        this.fallbackCopyTextToClipboard(text);
      }
    },

    // 备用复制方法
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand("copy");
        this.$message.success("已复制到剪贴板");
      } catch (err) {
        this.$message.error("复制失败，请手动复制");
      }

      document.body.removeChild(textArea);
    },
  },
};
</script>

<style lang="scss" scoped>
.url-download-logs {
  padding: 20px;

  .operation-bar {
    background-color: #fff;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .stats-row {
    margin-bottom: 20px;

    .stat-card {
      background: #fff;
      padding: 20px;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      transition: transform 0.3s ease;

      &:hover {
        transform: translateY(-2px);
      }

      .stat-icon {
        width: 56px;
        height: 56px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;

        i {
          font-size: 28px;
        }
      }

      .stat-content {
        flex: 1;

        .stat-value {
          font-size: 24px;
          font-weight: bold;
          color: #303133;
          margin-bottom: 4px;
        }

        .stat-label {
          font-size: 14px;
          color: #909399;
        }
      }
    }
  }

  .table-container {
    background-color: #fff;
    padding: 16px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }

  .detail-content {
    .user-agent-text {
      word-break: break-all;
      font-size: 12px;
      color: #606266;
      line-height: 1.5;
    }
  }
}
</style>
